<template>
  <div>
    <h4>{{ $t('登入中...') }}</h4>
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "登入中...": "登入中...",
    "錯誤": "錯誤",
    "確定": "確定",
    "登入成功": "登入成功",
    "即將返回首頁": "即將返回首頁",
  },
  en: {
    "登入中...": "Logging in...",
    "錯誤": "Error",
    "確定": "Confirm",
    "登入成功": "Successfully logged in",
    "即將返回首頁": "Returning to homepage soon",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Register",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      LoginData: {},
      local: "zh_tw",
    };
  },
  created: function () {
    //console.log('staNum: ' + this.$route.query.staNum);
    //console.log('staName: ' + this.$route.query.staName);
    //console.log(this.$route.query);
    let that = this;
    Vue.axios
      .get(
        this.$store.state.src +
        this.$store.state.subDirectory +
        "/Html/GetLoginInfo",
        {
          //params: { staNum: this.$route.query.staNum, staName: this.$route.query.staName },
          params: { SSOData: this.$route.query.SSOData },
        }
      )
      .then((response) => {
        this.LoginData = response.data;
        if (this.LoginData.Error) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: this.LoginData.Error,
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
            willClose: () => {
              that.$router.push({
                name: "Home",
              });
            },
          });
        } else {
          $cookies.set("dormitory_login_token", this.LoginData.LoginToken, "30d");
          // $cookies.set("is_login_Num", this.LoginData.Num, "30d");
          // $cookies.set("is_login_Name", this.LoginData.Name, "30d");
          Swal.fire({
            title: that.$t("登入成功"),
            text: that.$t("即將返回首頁"),
            icon: "success",
            allowOutsideClick: false,
            showConfirmButton: false,
            heightAuto: false,
            timer: 1500,
            willClose: () => {
              that.$router.push({
                name: "Home",
              });
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
  },
};
</script>
